module.exports = __webpack_public_path__ + "img/rat.a9a28e64.jpeg";